import { BaseService } from "@/script/core/service/BaseService";
import { Failure, Success } from "@/script/core/service/DataService";
import store from "@/store";

export class AuthService extends BaseService {
  public loadPermissionList(success: Success, failure?: Failure) {
    super.get("/api/sys/auth/permission/list", {}).then(
      function (result) {
        success(result.data);
      },
      function (error: Error) {
        if (failure) {
          failure(error);
        }
      }
    );
  }

  public innerLoadUserPermissionList(userId: number) {
    return super.get("/api/sys/auth/permission/list/user", { userId });
  }

  async loadUserPermissionList() {
    const permissions = store.getters.loginUserPermissions;
    if (permissions.length === 0) {
      const userId = store.getters.loginUser.id!;
      const result = await this.innerLoadUserPermissionList(userId);
      store.dispatch("changeLoginUserPermissions", result.data);
    }
  }
}
